
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import Stashsite from './components/Stashsite';
import { DataProvider } from './context/DataContext';
import { FeedbackProvider } from './context/FeedbackContext';
import { UIProvider } from './context/UIContext';
import { UserProvider } from './context/UserContext';
import { init } from './Sentry';

init();

function App() {

  const theme = createTheme({
    palette: {
      primary: {
        main: '#1a1a1a',
      },
      secondary: {
        main: '#c2410c',
      },
      error: {
        main: '#b91c1c',
      },
      background: {
        default: '#fafaf8',
      },
      divider: '#e5e5e3',
    },
    typography: {
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
      h1: { letterSpacing: '-0.025em' },
      h2: { letterSpacing: '-0.025em' },
      h3: { letterSpacing: '-0.02em' },
      h4: { letterSpacing: '-0.02em' },
      h5: { letterSpacing: '-0.015em' },
      h6: { letterSpacing: '-0.015em' },
      button: { textTransform: 'none' },
    },
    shape: {
      borderRadius: 6,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none',
            },
          },
          outlined: {
            borderColor: '#e5e5e3',
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#e5e5e3',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#c2410c',
              },
            },
            '& .MuiInputLabel-root.Mui-focused': {
              color: '#c2410c',
            },
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: 10,
            boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            border: '1px solid #e5e5e3',
            boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
          },
        },
      },
      MuiIconButton: {
        defaultProps: {
          color: 'default' as const,
        },
        styleOverrides: {
          root: {
            color: 'text.secondary',
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            color: '#1a1a1a',
            textDecorationColor: 'rgba(194, 65, 12, 0.4)',
            '&:hover': {
              textDecorationColor: '#c2410c',
            },
          },
        },
      },
    },
  });


  return (
    <UserProvider>
      <UIProvider>
        <FeedbackProvider>
          <DataProvider>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <Stashsite />
            </ThemeProvider>
          </DataProvider>
        </FeedbackProvider>
      </UIProvider>

    </UserProvider>
  );
}

export default App
